import {
	Res,
	PaymentDTO
} from 'core/api';
import { Message } from 'core/ui-next/modal';

import { CashdrawerFacade } from 'pos/facades';

export type Status = ClosingPaymentsData & ClosingPaymentsResult;

// Datos de los pagos que realizo
export type ClosingPaymentsData = {
	Payments: PaymentDTO[];
	AmountToPay: number;
};

// Resultado de realizar los pagos
export type ClosingPaymentsResult = {
	PaidAmount: number,
	ChangeAmount: number,
	PendingAmount: number,
	ErrorMessage: string,
	ThereIsEnoughChange: boolean
}


export type ProposedAmount = {
	amount: number;
	tip: number;
};

export async function refresh(status: Status, amountToPay: number, isRefund = false) {
	return checkPayments(status.Payments, amountToPay, isRefund);
}

async function checkPayments(payments: PaymentDTO[], amountToPay: number, isRefund = false): Promise<Status> {
	const result = await CashdrawerFacade.checkPayments(payments, amountToPay, isRefund);
	return {
		Payments: payments,
		PendingAmount: result.PendingAmount,
		AmountToPay: result.AmountToPay,
		PaidAmount: result.PaidAmount,
		ChangeAmount: result.ChangeAmount,
		ErrorMessage: result.ErrorMessage,
		ThereIsEnoughChange: result.ThereIsEnoughChange
	};
}

export async function checkNewPayment(status: Status, pendingAmount: number, payment: PaymentDTO, isRefund = false): Promise<{ ErrorMessage: string }> {
	if (status.PendingAmount === 0)
		return { ErrorMessage: Res.Msg.MSG_PAYMENTS_ARE_ENOUGH() };
	return await CashdrawerFacade.checkPayments([payment], pendingAmount > payment.Amount ? payment.Amount : pendingAmount, isRefund);
}

export async function add(state: Status, payment: PaymentDTO, isRefund = false): Promise<Status> {
	return await checkPayments([...state.Payments, payment], state.AmountToPay, isRefund);
}

export async function remove(state: Status, payment: PaymentDTO, isRefund = false): Promise<Status> {
	const payments = [...state.Payments];
	payments.remove(payment);
	return await checkPayments(payments, state.AmountToPay, isRefund);
}

export async function canPay(payments: PaymentDTO[], amountToPay: number, isRefund = false) {

	const { ErrorMessage, ThereIsEnoughChange } = await checkPayments(payments, amountToPay, isRefund);

	if (ErrorMessage) {
		await Message.show(ErrorMessage);
		return false;
	}

	if (!ThereIsEnoughChange) {
		const result = await Message.confirm(Res.Msg.MSG_CONFIRM_NOT_ENOUGH_CASH_TO_GIVE_CHANGE_ON_CLOSE_TICKET());
		if (!result.ok)
			return false;
	}

	return true;
}
